import { get, post } from './http';

const meetup = {
  getMeetupConf: (params) => {
    return get('/campaign/frontend/meetup-campaign/conf')
  },
  getHighlights: (params) => {
    return get('/campaign/frontend/meetup-campaign/case/highlight/gets', params)
  },
  getCasese: (params) => {
    return get('/campaign/frontend/meetup-campaign/case/query', params)
  },
  getFanhosts: (params) => {
    return get('/campaign/frontend/meetup-campaign/user/query', params)
  },
  getRecommendIp: (params) => {
    return get('/campaign/frontend/meetup-campaign/recommend/gets', params)
  },
  getRecommendUgcList: (params) => {
    return get('/campaign/frontend/meetup-campaign/thread', params)
  }
};
export default meetup;
